import React from 'react'
import ReactMarkdown from 'react-markdown'
import { getFontStyles } from '@ycos/primitives'
import { string, func, bool } from 'prop-types'

import { createComponent } from '@ycos/fela'

const ALLOWED_ELEMENTS = ['p', 'a']

const ParagraphText = createComponent(
  'ParagraphText',
  ({ theme, allowSkinnySale, brand }) => {
    let fontName
    if (allowSkinnySale && brand === 'nap') {
      fontName = '5'
    } else if (brand === 'theoutnet') {
      fontName = '4'
    } else {
      fontName = '3'
    }
    return {
      ...getFontStyles(theme.typography, { type: 'Paragraph', tagName: 'div', name: fontName }),
      color: theme.typography.colors.PrimaryWhite,
      lineHeight: '24px'
    }
  },
  'div'
)

const Link = createComponent(
  'Link',
  ({ theme, allowSkinnySale, brand }) => {
    let fontName
    if (allowSkinnySale && brand === 'nap') {
      fontName = '5'
    } else if (brand === 'theoutnet') {
      fontName = '4'
    } else {
      fontName = '3'
    }
    return {
      ...getFontStyles(theme.typography, { type: 'Paragraph', tagName: 'div', name: fontName }),
      color: theme.typography.colors.PrimaryWhite,
      lineHeight: '24px',
      textDecoration: 'underline',
      ':hover': {
        opacity: '0.8',
        transition: 'opacity 300ms cubic-bezier(0.3, 0.0, 0.3, 1.0)'
      }
    }
  },
  'a'
)

const Markdown = ({ teaserText, onDropdownLinkClick, allowSkinnySale, brand }) => {
  const renderParagraph = ({ children }) => (
    <ParagraphText allowSkinnySale={allowSkinnySale} brand={brand}>
      {children}
    </ParagraphText>
  )
  const renderLink = ({ children, href }) => (
    <Link href={href} onClick={() => onDropdownLinkClick()} allowSkinnySale={allowSkinnySale} brand={brand}>
      {children}
    </Link>
  )
  /* eslint-disable */
  // because eslint have rule (Disallow passing of children as props)
  return (
    <ReactMarkdown
      components={{
        p: renderParagraph,
        a: renderLink
      }}
      allowedElements={ALLOWED_ELEMENTS}
      children={teaserText}
    />
  )
  /* eslint-enable */
}

Markdown.propTypes = {
  teaserText: string.isRequired,
  onDropdownLinkClick: func,
  allowSkinnySale: bool,
  brand: string
}

Markdown.defaultProps = {
  onDropdownLinkClick: () => {},
  allowSkinnySale: false,
  brand: 'nap'
}

export default Markdown
